export default __webpack_public_path__ + "assets/images/8a3a9c0803f262dcd04c3832a327a509.png";